import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { cambiarcontrasena } from 'src/app/modelos/autenticacion/cambiarcontrasena';
import { LoginI } from 'src/app/modelos/login.interface';
import { ApiService } from 'src/app/servicios/api/api.service';

@Component({
  selector: 'app-cambioclave',
  templateUrl: './cambioclave.component.html',
  styleUrls: ['./cambioclave.component.css']
})
export class CambioclaveComponent implements OnInit {

  usuario:string = "";
  correo:string = "";
  nombre:string = "";
  tipoUsuario:string = "";

  CambiarContraseña : string;
  ContrasenaActual : string;
  ContrasenaNueva : string;
  ContrasenaConfirma : string;
  BtnCambiar : Boolean;

  ProbLog : LoginI;

  cambiarcontrasena : cambiarcontrasena = new cambiarcontrasena();

  PasswordNew = new FormControl('',[Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{8,16}$/)]);

  @ViewChild('openModalContrasena') openModalContrasena: ElementRef;
  @ViewChild('closeModalContrasena') closeModalContrasena: ElementRef;

  constructor(private api:ApiService, private router:Router, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.ProbLog = new LoginI;
    this.usuario = localStorage.getItem('usuario');
    this.ContrasenaActual = "";
    this.ContrasenaNueva = "";
    this.ContrasenaConfirma = "";
    this.BtnCambiar = false;
  }

  verificarContrasena(){
    this.BtnCambiar = true;
    this.ProbLog.username = this.usuario;
    this.ProbLog.password = this.ContrasenaActual;
    this.ContrasenaNueva = this.PasswordNew.value;
    this.api.loginUser(this.ProbLog).subscribe(data=>{
      localStorage.setItem("token",data.token);
      this.cambiarContrasena();
    }, error=>{
      this.toastr.error('Contraseña actual errada.', 'Error!');
    })
  }

  cambiarContrasena(){
    if(this.ContrasenaNueva == this.ContrasenaConfirma){
      this.BtnCambiar = true;
      this.cambiarcontrasena.idUsuario = localStorage.getItem('id');
      this.cambiarcontrasena.username = this.usuario;
      this.cambiarcontrasena.nueva = this.ContrasenaConfirma;
      this.api.cambiarContrasena(this.cambiarcontrasena).subscribe(
        data=>{
          if(data){
            this.toastr.success('Se cambio la contraseña.', 'OK!');
            this.onLogout();
          }else{
            this.toastr.error('No se pudo cambiar la contraseña.', 'Error!');
            this.onLogout();
          }
        },error=>{
          this.toastr.error('No se pudo cambiar la contraseña.', 'Error!');
          this.onLogout();
        }
      );




      /*this.api.getUsuarioByUsername(this.usuario).subscribe(Usuario=>{
        Usuario.password = this.ContrasenaConfirma;
        //Usuario.fuente = null;
        this.api.editarUsuario(Usuario).subscribe(data1=>{
          this.toastr.success('Se cambio la contraseña.', 'OK!');
          this.onLogout();
        }, error=>{
          this.toastr.error('No se pudo cambiar la contraseña.', 'Error!');
          this.ngOnInit();
        });
      },error=>{
        console.log(error);
      });*/
    } else {
      this.BtnCambiar = false;
      this.toastr.error('No coincide la nueva contraseña.', 'Error!');
    }
  }

  onLogout(){
    localStorage.clear();
    this.router.navigate(['login']);
  }

  regresar(){
    localStorage.clear();
    this.router.navigate(['login']);
  }

}
